import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "channel-customer" }

import { computed, onMounted, ref, watch } from 'vue'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'
import { CrudSearch, CrudTable } from '@/components/crud-v2'
import WatermarkCanvas from '@/components/Watermark.vue'
import { usePagedCrud } from '@/hooks/crud/usePagedCrud'
import {
  isSupersededRequestError,
  useLatestRequest
} from '@/hooks/crud/useLatestRequest'
import type {
  CrudSearchItem,
  CrudSelectOption,
  CrudTableColumn
} from '@/types/crud-config'
import {
  fetchChannelCustomerPage,
  fetchThirdParties,
  fetchChannelSources
} from './channel-customer.service'
import type {
  ChannelCustomerFilters,
  ChannelCustomerRecord
} from './channel-customer.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelCustomer',
  setup(__props) {

const thirdPartyOptions = ref<CrudSelectOption[]>([])
const sourceOptions = ref<CrudSelectOption[]>([])
const thirdPartyRequest = useLatestRequest()
const sourceRequest = useLatestRequest()

const searchItems = computed<CrudSearchItem[]>(() => [
  {
    prop: 'thirdParty',
    label: '所属第三方',
    type: 'select',
    placeholder: '请选择所属第三方',
    options: thirdPartyOptions.value,
    loading: thirdPartyRequest.isPending.value,
    clearable: true
  },
  {
    prop: 'sourceLabel',
    label: '渠道来源',
    type: 'select',
    placeholder: filters.thirdParty ? '请选择渠道来源' : '请先选择所属第三方',
    options: sourceOptions.value,
    loading: sourceRequest.isPending.value,
    disabled: (model) => !model.thirdParty,
    clearable: true
  },
  {
    prop: 'timeSlot',
    label: '加入时间',
    type: 'dateRange',
    valueFormat: 'YYYY-MM-DD',
    startPlaceholder: '开始日期',
    endPlaceholder: '结束日期',
    clearable: true,
    disabledDate: (date) => date.getTime() >= dayjs().startOf('day').valueOf()
  }
])

const columns: CrudTableColumn<ChannelCustomerRecord>[] = [
  { prop: 'corpName', label: '企业名称', minWidth: 160 },
  { prop: 'empId', label: '员工ID', minWidth: 160 },
  { prop: 'unionId', label: 'UnionID', minWidth: 220 },
  { prop: 'thirdParty', label: '所属第三方', minWidth: 160 },
  { prop: 'sourceLabel', label: '渠道来源', minWidth: 160 },
  { prop: 'joinDate', label: '加入时间', minWidth: 180 }
]

const {
  filters,
  records,
  total,
  pageNo,
  pageSize,
  loading,
  error,
  load,
  search,
  reset,
  changePage,
  changePageSize,
  refresh
} = usePagedCrud({
  createFilters: (): ChannelCustomerFilters => ({
    sourceLabel: '',
    thirdParty: '',
    timeSlot: [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
  }),
  fetchPage: fetchChannelCustomerPage
})

const errorMessage = computed(() =>
  error.value instanceof Error ? error.value.message : ''
)

watch(
  () => filters.thirdParty,
  async (thirdParty) => {
    sourceRequest.cancel()
    filters.sourceLabel = ''
    sourceOptions.value = []
    if (!thirdParty) return

    try {
      const sources = await sourceRequest.run((signal) =>
        fetchChannelSources(thirdParty, signal)
      )
      sourceOptions.value = sources.map((value) => ({ label: value, value }))
    } catch (cause) {
      if (isSupersededRequestError(cause)) return
      ElMessage.error('获取渠道来源失败，请重新选择所属第三方')
    }
  },
  { flush: 'sync' }
)

onMounted(async () => {
  load()
  try {
    const thirdParties = await thirdPartyRequest.run(fetchThirdParties)
    thirdPartyOptions.value = thirdParties.map((value) => ({
      label: value,
      value
    }))
  } catch (cause) {
    if (isSupersededRequestError(cause)) return
    ElMessage.error('获取所属第三方失败，请刷新页面重试')
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WatermarkCanvas),
    _createVNode(_unref(CrudSearch), {
      model: _unref(filters),
      items: searchItems.value,
      loading: _unref(loading),
      onSearch: _unref(search),
      onReset: _unref(reset)
    }, null, 8, ["model", "items", "loading", "onSearch", "onReset"]),
    _createVNode(_unref(CrudTable), {
      rows: _unref(records),
      columns: columns,
      "row-key": "",
      "page-no": _unref(pageNo),
      "page-size": _unref(pageSize),
      total: _unref(total),
      loading: _unref(loading),
      "error-message": errorMessage.value,
      onPageChange: _unref(changePage),
      onPageSizeChange: _unref(changePageSize),
      onRetry: _unref(refresh)
    }, {
      title: _withCtx(() => [
        _createTextVNode("获客渠道资源列表")
      ]),
      _: 1
    }, 8, ["rows", "page-no", "page-size", "total", "loading", "error-message", "onPageChange", "onPageSizeChange", "onRetry"])
  ]))
}
}

})